ixModuleRouting("impactx.message", {
    "/messageinfolist": {
        template: "<ixa-message-info-list></ixa-message-info-list>",
        templateUrl: "modules/message/templates/messageinfolist.html",
        controller: "MessageInfoListCtrl",
        controllerAs: "messageInfoListCtrl",
        process: "SendMessage",
    },
    "/messagetodolist": {
        template: "<ixa-message-todo-list></ixa-message-todo-list>",
        templateUrl: "modules/message/templates/messagetodolist.html",
        controller: "MessageTodoListCtrl",
        controllerAs: "messageTodoListCtrl",
        process: "SendMessage",
    },
    "/message/:id": {
        template: "<ixa-message-detail></ixa-message-detail>",
        process: "Message",
    },
    "/message/:id/reply": {
        template: "<ixa-message-detail></ixa-message-detail>",
        templateUrl: "modules/message/templates/messagedetail.html",
        controller: "MessageReplyCtrl",
        controllerAs: "messageDetailCtrl",
        process: "Message",
    },
    "/contactmessage/:recipientuserid/:recipientusername": {
        template: "<ixa-message-detail></ixa-message-detail>",
        templateUrl: "modules/message/templates/messagedetail.html",
        controller: "MessageDetailCtrl",
        controllerAs: "messageDetailCtrl",
        process: "Message",
    },
});
